import {
    IsString,
    Length,
    IsNotEmpty,
    IsOptional,
    IsEmail,
    ValidateIf,
} from 'class-validator';

import { useSignInIdentities } from 'src/view/hooks/useSignInIdentities';
import Form from 'src/components/FormComponents/Form';
import Input from 'src/components/FormComponents/Input';
import {
    DesktopIcon,
    EnvelopeIcon,
    PhoneIcon,
} from 'src/components/Icons/icons';
import { Admin } from 'src/domain/admin';
import { TextIcon } from 'src/components/Icons/TextIcon';
import i18n from 'src/i18n';
import { useTranslation } from 'react-i18next';

class AdminSchema {
    @IsOptional()
    @IsString()
    @Length(2, 30, {
        message: () => i18n.t('validation.lengthBetween', { min: 2, max: 30 }),
    })
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    firstName?: string;

    @IsOptional()
    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    lastName?: string;

    @IsOptional()
    @ValidateIf(o => o.email?.length !== 0)
    @IsString()
    @IsEmail({}, { message: () => i18n.t('validation.invalidEmail') })
    email?: string;
}

export const AdminProfile = ({ user }: { user: Admin }) => {
    const { phoneNumber } = useSignInIdentities(user.id);
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-8 max-w-3xl mx-auto">
            <Form
                className="bg-lightPeach text-woodyBrown"
                schema={AdminSchema}
                mode="onChange"
                defaultValues={{
                    email: user.email,
                    firstName: user.profile.firstName,
                    lastName: user.profile.lastName,
                }}
            >
                {({ register, formState: { errors } }) => (
                    <div className="grid grid-cols-2 gap-4 h-full">
                        <div className="col-span-full flex justify-center">
                            {/* TODO: Replace with Role icon when ready */}
                            <div className="rounded-full w-36 h-36 bg-starkWhite flex justify-center items-center mb-4 text-[18px] stroke-2 ">
                                <TextIcon SVG={DesktopIcon} />
                            </div>
                        </div>
                        <Input
                            className="text-input"
                            type="text"
                            label={t('nextOfKin.form.firstName')}
                            error={errors.firstName}
                            readOnly
                            {...register('firstName')}
                        />
                        <Input
                            className="text-input"
                            type="text"
                            label={t('nextOfKin.form.lastName')}
                            error={errors.lastName}
                            readOnly
                            {...register('lastName')}
                        />
                        <Input
                            className="text-input"
                            type="tel"
                            label={t('profile.labels.phone')}
                            leadingIcon={PhoneIcon}
                            value={phoneNumber || ''}
                            readOnly
                        />
                        <Input
                            className="text-input"
                            type="email"
                            label={t('profile.labels.email')}
                            error={errors.email}
                            leadingIcon={EnvelopeIcon}
                            readOnly
                            {...register('email')}
                        />
                    </div>
                )}
            </Form>
        </div>
    );
};
